export default __webpack_public_path__ + "static/media/gallery_06.01462950.jpg";